@if (showNotification) {
    <div class="update-notification">
        <div class="update-content">
            <app-icon icon="cog"></app-icon>
            <span class="update-message" i18n>A new version is available</span>
            <div class="update-actions">
                <button matButton="filled" color="primary" (click)="applyUpdate()" i18n>
                    Update Now
                </button>
                <button matButton="text" (click)="dismiss()" i18n>
                    Later
                </button>
            </div>
        </div>
    </div>
}